export const FIND_OR_CREATE_REQUESTED = 'find_or_create_requested';
export const FIND_OR_CREATE_SUCCESS = 'find_or_create_success';
export const FIND_OR_CREATE_FAILURE = 'find_or_create_failure';

export const STORE_FIND_OR_CREATE_REQUESTED = 'store_find_or_create_requested';
export const STORE_FIND_OR_CREATE_SUCCESS = 'store_find_or_create_success';
export const STORE_FIND_OR_CREATE_FAILURE = 'store_find_or_create_failure';

export const STORE_SETTINGS_FIND_REQUESTED = 'store_settings_find_requested';
export const STORE_SETTINGS_FIND_SUCCESS = 'store_settings_find_success';
export const STORE_SETTINGS_FIND_FAILURE = 'store_settings_find_failure';

export const USER_FIND_OR_CREATE_REQUESTED = 'user_find_or_create_requested';
export const USER_FIND_OR_CREATE_SUCCESS = 'user_find_or_create_success';
export const USER_FIND_OR_CREATE_FAILURE = 'user_find_or_create_failure';

export const PAYMENT_REQUESTED = 'payment_requested';
export const PAYMENT_SUCCESS = 'payment_success';
export const PAYMENT_FAILURE = 'payment_failure';

export const PAYMENT_SESSION_REQUESTED = 'payment_session_requested';
export const PAYMENT_SESSION_SUCCESS = 'payment_session_success';
export const PAYMENT_SESSION_FAILURE = 'payment_session_failure';

export const PAYMENT_VERIFICATION_REQUESTED = 'payment_verification_requested';
export const PAYMENT_VERIFICATION_SUCCESS = 'payment_verification_success';
export const PAYMENT_VERIFICATION_FAILURE = 'payment_verification_failure';

export const SETTINGS_REQUESTED = 'settings_requested';
export const SETTINGS_SUCCESS = 'settings_success';
export const SETTINGS_FAILURE = 'settings_failure';

export const SETTINGS_UPDATE_REQUESTED = 'settings_update_requested';
export const SETTINGS_UPDATE_SUCCESS = 'settings_update_success';
export const SETTINGS_UPDATE_FAILURE = 'settings_update_failure';

export const UPLOAD_TOKEN_REQUESTED = 'upload_token_requested';
export const UPLOAD_TOKEN_SUCCESS = 'upload_token_success';

export const LOGO_UPLOAD_REQUESTED = 'logo_upload_requested';
export const LOGO_UPLOAD_SUCCESS = 'logo_upload_success';
export const LOGO_UPLOAD_FAILURE = 'logo_upload_failure';

export const LOCATIONS_INDEX_REQUESTED = 'locations_index_requested';
export const LOCATIONS_INDEX_SUCCESS = 'locations_index_success';
export const LOCATIONS_INDEX_FAILURE = 'locations_index_failure';

export const CART_LAYOUTS_REQUESTED = 'cart_layouts_requested';
export const CART_LAYOUTS_SUCCESS = 'cart_layouts_success';
export const CART_LAYOUTS_FAILURE = 'cart_layouts_failure';

export const CART_LAYOUT_FIND_REQUESTED = 'cart_layout_find_requested';
export const CART_LAYOUT_FIND_SUCCESS = 'cart_layout_find_success';
export const CART_LAYOUT_FIND_FAILURE = 'cart_layout_find_failure';

export const CART_LAYOUT_CREATE_REQUESTED = 'cart_layout_create_requested';
export const CART_LAYOUT_CREATE_SUCCESS = 'cart_layout_create_success';
export const CART_LAYOUT_CREATE_FAILURE = 'cart_layout_create_failure';

export const CART_LAYOUT_UPDATE_REQUESTED = 'cart_layout_update_requested';
export const CART_LAYOUT_UPDATE_SUCCESS = 'cart_layout_update_success';
export const CART_LAYOUT_UPDATE_FAILURE = 'cart_layout_update_failure';

export const CART_LAYOUT_DELETE_REQUESTED = 'cart_layout_delete_requested';
export const CART_LAYOUT_DELETE_SUCCESS = 'cart_layout_delete_success';
export const CART_LAYOUT_DELETE_FAILURE = 'cart_layout_delete_failure';


export const ZONES_REQUESTED = 'zones_requested';
export const ZONES_SUCCESS = 'zones_success';
export const ZONES_FAILURE = 'zones_failure';

export const ZONE_FIND_REQUESTED = 'zone_find_requested';
export const ZONE_FIND_SUCCESS = 'zone_find_success';
export const ZONE_FIND_FAILURE = 'zone_find_failure';

export const ZONE_CREATE_REQUESTED = 'zone_create_requested';
export const ZONE_CREATE_SUCCESS = 'zone_create_success';
export const ZONE_CREATE_FAILURE = 'zone_create_failure';

export const ZONE_UPDATE_REQUESTED = 'zone_update_requested';
export const ZONE_UPDATE_SUCCESS = 'zone_update_success';
export const ZONE_UPDATE_FAILURE = 'zone_update_failure';

export const ZONE_DELETE_REQUESTED = 'zone_delete_requested';
export const ZONE_DELETE_SUCCESS = 'zone_delete_success';
export const ZONE_DELETE_FAILURE = 'zone_delete_failure';



// export const _REQUESTED = '_requested';
// export const _SUCCESS = '_success';
// export const _FAILURE = '_failure';
